import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BankStatementRuleConditionTypeEnum } from '@zaoblako/shared/modules/document/enums/bank.statement.rule.condition.type.enum';
import { BankStatementRuleConditionTypeEnumI18n } from '@zaoblako/shared/modules/document/i18n/bank.statement.rule.condition.type.enum.i18n';

@Pipe({
  name: 'bankStatementRuleConditionTypeName',
  standalone: true
})
export class BankStatementRuleConditionTypeNamePipe implements PipeTransform {
  public transform(type: BankStatementRuleConditionTypeEnum): string {
    return BankStatementRuleConditionTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || '';
  }
}
